import React, { useEffect, useRef, useState } from "react";
import { columnsCsv, options } from "./../../users/registartionDetail/content";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../../common/notification-message/notification";

import ReferrerCodeheader from "./referrerCodeHeader";
import { Referrercodedata } from "../manageuserVerification/mockdata";
import { getDeleteList } from "../manageuserVerification/utils";
import { getReferrerCodeList } from "../manageuserVerification/utils";
import moment from "moment";
import { useHistory } from "react-router-dom";

let rowsdata = [];
const ReferrerCode = (props) => {
  const history = useHistory();
  const request = {
    page: 1,
    size: 10,
    date: "",
    name: "",
    code: "",
    action: "",

    searchFilter: "",
  };
  const [filterForm, setFilterForm] = useState(request);
  const [noData, setNoData] = useState(false);
  const [deleteuser, setDeleteUserShow] = useState(false);
  const [reassignshow, setReassignshow] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [searchBy, setSearchBy] = useState("name");
  const [searchByValue, setSearchByValue] = useState("");
  const [filterValues, setFilterValues] = useState(false);
  const [adminStatus, setAdminStatus] = useState(false);
  const [superadminStatus, setSuperadminStatus] = useState(false);
  const [callcentreagentStatus, setCallcentreagentStatus] = useState(false);
  const [customerserviceStatus, setCustomerserviceStatus] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [noOfFiltersSelected, setNoOfFiltersSelected] = useState(false);
  const [filtersSelected, setFiltersSelected] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [ReferrerCodeList, setReferrerCodeList] = useState([]);
  const [ReffererCodeConstData, setReffererCodeConstData] = useState([]);
  const [DeleteList, setDeleteList] = useState([]);
  const [beneficiaryid, setBeneficiaryid] = useState(); // send  conformation
  const [searchResult, setsearchResult] = useState([]);
  const [deleteLoader, setDeleteLoader] = useState(false);

  const [rowId, setRowId] = useState("");
  const [ReferrerCodeListExcel, setReferrerCodeListExcel] = useState([]);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });
  const [sizeShow, setSizeShow] = useState();
  const buttonRef = useRef("");

  const columns = [
    {
      dataField: "action",
      text: "Action",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "50px", textAlign: "center" },
      formatter: (cell, row) => {
        return (
          <>
            <i
              style={{ fontSize: 18 }}
              className="fas fa-trash-alt"
              style={{ color: "black" }}
              onClick={() => {
                if (row && row.id) {
                  setRowId(row.id);
                }
                setDeleteUserShow(true);
              }}
            />
          </>
        );
      },
    },
    {
      dataField: "name",
      text: "Name",
      sort: false,
      headerStyle: { textAlign: "left" },
      style: { maxWidth: "100px", textAlign: "left" },
    },
    {
      dataField: "code",
      text: "Code ",
      sort: false,
      headerStyle: { textAlign: "left" },
      style: { maxWidth: "100px", textAlign: "left" },
    },
  ];

  const rowOnClick = (data) => {
    let states = { ...data };
    history.push({
      pathname: "/admin/user-profile",
      state: { id: states.id, rowData: states },
    });
    console.log("Bishen");
  };

  useEffect(() => {
    if (filterForm) {
      getReferrerCodes(filterForm);
    }
  }, [filterForm]);

  const getReferrerCodes = (request) => {
    request.size = sizeShow || 10;
    setDataLoading(true);
    getReferrerCodeList(request)
      .then((res) => {
        setDataLoading(false);

        if (res && res.data && res.data.users.length > 0) {
          setReferrerCodeList(() => res.data.users);
          setReffererCodeConstData(() => res.data.users);
        } else {
          setNoData(true);

          setReferrerCodeList([]);
          setReffererCodeConstData([]);
        }
        setPagination({
          ...pagination,
          pageSize: sizeShow || 10,
          total: res.data.totalCount,
          current: request.page,
        });
      })
      .catch((err) => {
        setPagination({ ...pagination, pageSize: 10, total: 0, current: 1 });
        setDataLoading(false);
        setReferrerCodeList(); //mockdata:getReferrerCodedata
      });
  };
  //  delete api
  const onDelete = () => {
    console.log("Delete row", rowId);

    setDeleteLoader(true);
    getDeleteList(rowId)
      .then((res) => {
        setDeleteUserShow(false);
        setDeleteLoader(false);
        //message.success("Delete Successfully");
        openNotificationWithIcon(
          notificationStrings.success,
          "Deleted Successfully"
        );

        getReferrerCodes(filterForm);

        // getReferrerCodeList(filterForm, username);
      })
      .catch((err) => {
        setDeleteUserShow(false);
        openNotificationWithIcon(
          notificationStrings.error,
          "Delete Unsuccessfull"
        );
        setDeleteLoader(false);
      });
  };

  const resetFilter = () => {
    setSearchBy("name");
    // setSearchByValue('');
    setFiltersSelected(false);
    setReferrerCodeList([]);
    setReferrerCodeListExcel([]);
    setReffererCodeConstData([]);
    setSelectedOption("");
    setFilterValues(false);
    setSearchByValue("");

    setFilterForm(request);
  };

  const searchFilter = () => {
    let request = {};
    if (searchBy === "name") {
      request = {
        ...filterForm,
        name: searchByValue,
      };
    }
    if (searchBy === "code") {
      request = {
        ...filterForm,
        code: searchByValue,
      };
    }
    request.page = 1;
    request.size = null;
    // TODO - NEED TO REMOVE
    setFilterForm(request);
  };

  const handleChange = (selectedOption) => {
    console.log(selectedOption);
    if (selectedOption) {
      setSelectedOption([...selectedOption]);
    } else {
      setSelectedOption("");
    }
  };

  let searchByValuePlaceholder = "";
  if (searchBy === "name") {
    searchByValuePlaceholder = "Amit Pandit";
  } else if (searchBy === "code") {
    searchByValuePlaceholder = "AM123";
  } else {
    searchByValuePlaceholder = "Pandit";
  }

  const onExcelClciked = (filterForm) => {
    let request = filterForm;
    request.page = 1;
    request.size = "";
    getReferrerCodeList(request)
      .then((res) => {
        if (res && res.data && res.data.users.length > 0) {
          let data = res.data.users.map((element) => {
            if (element.registrationDate) {
              element.registrationDate = moment(
                element.registrationDate
              ).format("DD-MM-YYYY");
            }
            return element;
          });
          setReferrerCodeListExcel(() => data);
          buttonRef.current.click();
        } else {
          setReferrerCodeListExcel([]);
        }
      })
      .catch((err) => {
        setReferrerCodeListExcel([]);
      });
  };

  return (
    <ReferrerCodeheader
      searchBy={searchBy}
      searchFilter={searchFilter}
      searchResult={searchResult}
      setSearchByValue={setSearchByValue}
      setSearchBy={setSearchBy}
      // searchByValuePlaceholder={searchByValuePlaceholder}
      searchByValue={searchByValue}
      setDeleteUserShow={setDeleteUserShow}
      setReassignshow={setReassignshow}
      filtersSelected={filtersSelected}
      noOfFiltersSelected={noOfFiltersSelected}
      resetFilter={resetFilter}
      modalShow={modalShow}
      setModalShow={setModalShow}
      filterValues={filterValues}
      ReferrerCodeList={ReferrerCodeList}
      dataLoading={dataLoading}
      buttonRef={buttonRef}
      filterForm={filterForm}
      onExcelClciked={onExcelClciked}
      ReferrerCodeListExcel={ReferrerCodeListExcel}
      columns={columns}
      columnsCsv={columnsCsv}
      pagination={pagination}
      setFilterForm={setFilterForm}
      setSizeShow={setSizeShow}
      deleteuserShow={deleteuser}
      reassignshow={reassignshow}
      handleChange={handleChange}
      options={options}
      rowId={rowId}
      onDelete={onDelete}
      deleteLoader={deleteLoader}
      rowOnClick=""
      selectedOption={selectedOption}
    />
  );
};

export default ReferrerCode;
